import type { EscalationListStatus } from '../api/result';

export const PORTAL_ESCALATION_STEPS = [
  'Escalation Submitted',
  'Agent Assigned',
  'In Progress',
  'Closed',
] as const;

export type PortalEscalationStep = (typeof PORTAL_ESCALATION_STEPS)[number];

export function isPortalEscalationClosed(status?: EscalationListStatus): boolean {
  return status?.step === 'Closed';
}

export function isPortalEscalationTerminal(step?: string): boolean {
  return step === 'Closed' || step === 'Not Required';
}

export function getStatusPresentation(status?: EscalationListStatus): { label: string; color: string } {
  return {
    label: status?.step ?? 'Escalation Submitted',
    color: status?.color ?? 'gray',
  };
}
